import React, {useState} from 'react';
import PropTypes from 'prop-types';
import './CopyToClipboard.less';

const CopyToClipboard = ({copyText, tooltipText}) => {
  const [isCopied, setIsCopied] = useState(false);

  const onCopyText = () => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1500);
  };

  const copyToClipboard = (e, text) => {
    e.stopPropagation();
    navigator.clipboard.writeText(text).then(() => onCopyText());
  };

  const iconStyle = {width: '20px', height: '20px', fill: '#5672C4'};
  const checkSpanStyle = {minWidth: '0', color: '#5672C4'};

  // eslint-disable-next-line max-len
  const copyImg  = <div className="tooltip-trigger"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={ iconStyle }><path d="M64 464H288c8.8 0 16-7.2 16-16V384h48v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h64v48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM224 304H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16V288c0 8.8 7.2 16 16 16zm-64-16V64c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64z"/></svg></div>;
  // eslint-disable-next-line max-len
  const checkImg = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={ iconStyle }><path d="M470.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 338.7 425.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>;

  return (
    <button type='button' className="CopyToClipboard" onClick={(e) => copyToClipboard(e, copyText)}>
      {isCopied ? checkImg : copyImg}
      {isCopied ? <span style={ checkSpanStyle }>Copied!</span>
                : <div className="tooltip"><div className="tooltip-text">{ tooltipText }</div></div>
      }
    </button>
  );
}

CopyToClipboard.propTypes = {
  copyText: PropTypes.string,
  tooltipText: PropTypes.string
};

CopyToClipboard.defaultProps = {
  copyText: '',
  tooltipText: 'Copy to clipboard'
};

export default CopyToClipboard;
